import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaProduto from '../../../../../lib/json/consultas/Produtos.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../../components/BootBox";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import { CelBreak25 } from "../../../../components/GridCell/styles";

function ListaProduto(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const EmpFilLogado = localStorage.getItem('empresaFilial');    

    const columns = [
        {
            Header: 'Produto',
            accessor: 'B1_COD',
        },
        {
            Header: 'Descrição',
            accessor: 'DESCRI',
            Cell: (item) => {
                return <CelBreak25>{item.value.trim()}</CelBreak25>
            }
        },
        {
            Header: 'Cta. Operacional',
            accessor: 'B1_XCONTA',
        },
        {
            Header: 'Cta. Corporativa',
            accessor: 'B1_CONTA',
        }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [data, setData]   = useState([]);
    var consultaDefault  = ConsultaProduto.consulta;

    useEffect(() => {
        loadProduto();
    }, []);

    // Processa consulta do grid
    const loadProduto = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaProduto.tabelas, EmpFilLogado )
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.B1_COD.trim()}/${row.original.EMPRESA}${row.original.M0_CODFIL.trim()}`)
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage 
                    text="Produto"
                    exibirIncluir={false}
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadProduto}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}
                        ]}
                        paginacao={250}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaProduto;